import { lazy } from 'react';

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const PrimaryCategoryConfigListViewChunk = lazy(() =>
  import('../feature-sets/PrimaryCategoryConfigListView').then(
    ({ PrimaryCategoryConfigListView }) => ({
      default: PrimaryCategoryConfigListView,
    })
  )
)

export const PrimaryCategoryConfigListPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.settingsTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('PrimaryCategoryConfigListPage', { tab: 'active' }),
          name: intl.formatMessage(messages.managePrimaryCategoriesTitle),
        },
      ]}
    >
      <PrimaryCategoryConfigListViewChunk />
    </Page>
  )
}
